import type { FunctionComponent } from 'react';
import { differenceInDays } from 'date-fns';

import { forTemplate, localizeCount } from '@trello/legacy-i18n';
import { EnterpriseIcon } from '@trello/nachos/icons/enterprise';
import { token } from '@trello/theme';

import styles from './LegacySandboxEnterpriseBanner.less';

const format = forTemplate('sandbox_enterprise_banner');

/** @deprecated */
interface LegacySandboxEnterpriseBannerProps {
  expiryDate?: string | null;
}

/** @deprecated */
export const LegacySandboxEnterpriseBanner: FunctionComponent<
  LegacySandboxEnterpriseBannerProps
> = ({ expiryDate }) => {
  const remainingDays = expiryDate
    ? differenceInDays(new Date(expiryDate), new Date())
    : -1;

  return (
    <div className={styles.banner}>
      <div className={styles.text}>
        <span className={styles.icon}>
          <EnterpriseIcon
            size="medium"
            color={token('color.text.inverse', '#FFFFFF')}
          />
        </span>
        <strong>
          {format('sandbox-enterprise')}{' '}
          {remainingDays >= 0 && (
            <span data-testid="expiry-days">
              {localizeCount('sandbox expiry days remaining', remainingDays)}
            </span>
          )}
        </strong>
      </div>
    </div>
  );
};
